import { render, staticRenderFns } from "./FormLayout.vue?vue&type=template&id=2c84556a"
import script from "./FormLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./FormLayout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports